import React from 'react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();
  const paragraphs = [t('about.p1'), t('about.p2'), t('about.p3')];

  return (
    <section id="about" data-testid="about-section" className="py-24 bg-[#0a1628] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#00D4FF]/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#00E5A0]/10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 data-testid="about-title" className="text-4xl md:text-5xl font-bold text-[#00D4FF] mb-4 inline-block relative">
              {t('about.title')}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#00E5A0] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
            </h2>
            <div className="w-32 h-1 bg-[#00E5A0] mx-auto mt-4"></div>
          </div>

          <div className="grid md:grid-cols-1 gap-8 text-center md:text-justify">
            {paragraphs.map((paragraph, index) =>
            <div
              key={index}
              className="bg-[#1a2942]/30 backdrop-blur-sm p-8 rounded-lg border border-[#00D4FF]/20 hover:border-[#00E5A0]/60 transition-all duration-300 hover:transform hover:scale-[1.02] hover:shadow-xl hover:shadow-[#00D4FF]/20">
                <p className="!text-xl text-white">
                  {paragraph}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default About;